import {
  DASHBOARD_FAILURE,
  DASHBOARD_REQUEST,
  DASHBOARD_SUCCESS,
} from 'common/dashboard/containers/constants';
import {
  GET_ORDER_DETAILS_FAILURE,
  GET_ORDER_DETAILS_REQUEST,
  GET_ORDER_DETAILS_SUCCESS,
} from 'order/details/containers/details-constants';
import { combineReducers } from 'redux';
import { combineActions, handleActions } from 'redux-actions';
import {
  CALL_INFO_SUCCESS,
  NOTIFICATION_INFO_SUCCESS,
} from '../../../notification_call/containers/constants';
import * as alertTypes from './alert-constants';

export const data = handleActions(
  {
    [combineActions(
      DASHBOARD_REQUEST,
      DASHBOARD_FAILURE,
      GET_ORDER_DETAILS_FAILURE,
    )]: () => [],
    [GET_ORDER_DETAILS_REQUEST]: (state, { payload }) => payload?.skipLoading ? state : [],
    [DASHBOARD_SUCCESS]: (state, { payload }) => payload.details.alerts || [],
    [combineActions(
      GET_ORDER_DETAILS_SUCCESS,
      CALL_INFO_SUCCESS,
      NOTIFICATION_INFO_SUCCESS,
    )]: (state, { payload }) => payload.alerts || [],
    [combineActions(
      alertTypes.ALERT_SNOOZE_SUCCESS,
      alertTypes.ALERT_DISCARD_SUCCESS,
    )]: (state, { payload }) => {
      if (!payload.blockId) {
        return state?.filter(a => a.id !== payload.id);
      }
      return state;
    },
  },
  [],
);

export const isSaving = handleActions(
  {
    [combineActions(
      alertTypes.ALERT_SNOOZE_REQUEST,
      alertTypes.ALERT_DISCARD_REQUEST,
    )]: (state, { payload }) => ({ [payload.id]: true }),
    [combineActions(
      alertTypes.ALERT_SNOOZE_SUCCESS,
      alertTypes.ALERT_SNOOZE_FAILURE,
      alertTypes.ALERT_DISCARD_SUCCESS,
      alertTypes.ALERT_DISCARD_FAILURE,
    )]: () => ({}),
  },
  {},
);

export default combineReducers({
  data,
  isSaving,
});
